import { Box, Button, Icon, Image, Text, Tooltip } from "@chakra-ui/react";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { FaArrowRight } from "react-icons/fa";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { NO_ACCESS_TO_CREATE_AI_DOCUMENT } from "../_utils/constants";
import TldrAiBase from "./TldrAiBase";
import TldrVideoInAction from "./TldrVideoInAction";

class TldrAiCard extends Component {
  render() {
    const { workspacePermissionChecks, t } = this.props;
    const { canCreateAIDocument } = workspacePermissionChecks;
    return (
      <Box className="ai-card-base">
        <Box as={TldrAiBase} mb={4}>
          <div
            className="ai-card-container"
            style={{ width: this.props.isMobileView ? "100%" : "341px" }}
          >
            <Image
              src={this.props.item.image}
              alt={this.props.item.heading}
              className="ai-card-image"
              display={this.props.isMobileView ? "none" : "block"}
            />

            <div className="ai-card-text-holder">
              <Text
                className={`ai-card-heading`}
                mt={this.props.isMobileView ? 4 : 6}
                display="flex"
                alignItems={"center"}
              >
                {this.props.item.icon && (
                  <Icon
                    color="brand.primary"
                    as={this.props.item.icon}
                    mr={2}
                  />
                )}{" "}
                {this.props.item.heading}
              </Text>
              <p className="ai-card-title">{this.props.item.title}</p>
              {this.props.item.videoInAction !== "" && (
                <TldrVideoInAction
                  title={this.props.item.buttonTitle}
                  videoInAction={this.props.item.videoInAction}
                ></TldrVideoInAction>
              )}
              <p className="ai-card-description">
                {this.props.item.description}
              </p>
            </div>
            <Tooltip
              hasArrow
              label={
                !canCreateAIDocument
                  ? NO_ACCESS_TO_CREATE_AI_DOCUMENT
                  : t("create_doc")
              }
            >
              {/* TODO: Restrcuture Card Design such a way that buttton don't need margin and padding */}
              <Button
                rightIcon={<FaArrowRight />}
                variant="outline"
                width="90%"
                m="23px 16px 16px"
                onClick={(e) => {
                  if (!canCreateAIDocument) {
                    return;
                  }
                  this.props.onCardClick();
                }}
              >
                {this.props.item.buttonTitle}
              </Button>
            </Tooltip>
          </div>
        </Box>
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  workspacePermissionChecks: state.permissions.workspacePermissionChecks,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({});

export default withTranslation(["ai"])(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(TldrAiCard))
);
